import React, { useState } from 'react';
import { Users, Package, ArrowRightLeft, LucideIcon } from 'lucide-react';
import { PrimaryBtn } from '../components/UI';

interface Slide {
  emoji?: string;
  Icon?: LucideIcon;
  color: string;
  title: string;
  text: string;
}

const SLIDES: Slide[] = [
  {
    emoji: '👋',
    color: 'var(--green)',
    title: 'Velkommen til Toolshare.no!',
    text: 'Del verktøy og utstyr med venner, naboer og nabolaget – i stedet for at alle kjøper sitt eget.',
  },
  {
    Icon: Users,
    color: 'var(--blue)',
    title: 'Bli med i en gruppe',
    text: 'Du organiseres i grupper – f.eks. venner eller naboer. Opprett en ny gruppe, eller bli med i en eksisterende med en invitasjonskode.',
  },
  {
    Icon: Package,
    color: 'var(--green)',
    title: 'Legg til dine ting',
    text: 'Registrer det du eier i Inventar – ta bilde og la AI fylle ut navn og beskrivelse automatisk. Merk tingene du er villig til å låne ut.',
  },
  {
    Icon: ArrowRightLeft,
    color: 'var(--amber)',
    title: 'Lån og lån ut',
    text: 'Se hva andre i gruppen kan låne ut under Oversikt, og be om å låne direkte i appen. Du får varsel når noen vil låne noe av deg.',
  },
];

export const OnboardingCarousel: React.FC<{ onDone: () => void }> = ({ onDone }) => {
  const [step, setStep] = useState(0);
  const isLast = step === SLIDES.length - 1;
  const slide = SLIDES[step];

  return (
    <div style={{ position: 'absolute', inset: 0, background: 'var(--surface-solid)', zIndex: 200, display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 'calc(var(--safe-top) + 14px) 16px 0' }}>
        <button onClick={onDone} style={{ background: 'none', border: 'none', color: 'var(--text3)', fontSize: 14, fontWeight: 500, cursor: 'pointer', padding: 6 }}>
          Hopp over
        </button>
      </div>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '0 28px 20px', textAlign: 'center' }}>
        {slide.emoji
          ? <div style={{ fontSize: 64, marginBottom: 20 }}>{slide.emoji}</div>
          : slide.Icon && (
              <div style={{ width: 88, height: 88, borderRadius: '50%', background: slide.color + '22', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
                <slide.Icon size={40} color={slide.color} strokeWidth={1.8} />
              </div>
            )}
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 10, letterSpacing: -0.3 }}>{slide.title}</h1>
        <p style={{ fontSize: 15, color: 'var(--text2)', lineHeight: 1.6, maxWidth: 300 }}>{slide.text}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginBottom: 20 }}>
        {SLIDES.map((_, i) => (
          <div key={i} style={{ width: i === step ? 18 : 6, height: 6, borderRadius: 3, background: i === step ? 'var(--green)' : 'var(--border-strong)', transition: 'width 0.2s' }} />
        ))}
      </div>

      <div style={{ padding: '0 24px calc(var(--safe-bottom) + 24px)' }}>
        <PrimaryBtn onClick={() => (isLast ? onDone() : setStep(s => s + 1))}>
          {isLast ? 'Kom i gang' : 'Neste'}
        </PrimaryBtn>
      </div>
    </div>
  );
};
